import { render, staticRenderFns } from "./cardInternationalVoiceProduct.vue?vue&type=template&id=35fd50c7&scoped=true"
import script from "./cardInternationalVoiceProduct.vue?vue&type=script&lang=js"
export * from "./cardInternationalVoiceProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd50c7",
  null
  
)

export default component.exports